import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageUploadButton from "../../layouts/ImageUploadButton";
import {
  getInstructionsImage,
  updateInstructionsImage,
} from "../../../actions/admin";

const Instruction = () => {
  const dispatch = useDispatch();

  // Image is stored in Redux
  const instructionImage = useSelector(
    (state) => state.admin.instructionsImage,
  );

  const user = useSelector((state) => state.auth.user);

  console.log("User: ", user);

  const [imageLoading, setImageLoading] = useState(!instructionImage);

  useEffect(() => {
    // Only call API if image isn't already in Redux
    if (!instructionImage) {
      setImageLoading(true);
      dispatch(getInstructionsImage());
    }
  }, [dispatch, instructionImage]);

  const handleUpload = async (file) => {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async () => {
      try {
        setImageLoading(true);

        const image = reader.result;

        await dispatch(
          updateInstructionsImage({
            instructionImg: image,
            imgFileName: file.name,
          }),
        );

        // Update Redux with the newly uploaded image
        dispatch({
          type: "GET_INSTRUCTIONS_IMAGE",
          payload: image,
        });
      } catch (error) {
        console.error(error);
        setImageLoading(false);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="container my-5" style={{ maxWidth: "960px" }}>
      {user.UserTypeID == 5 && (
        <div className="d-flex justify-content-end mb-3">
          <ImageUploadButton onUpload={handleUpload} />
        </div>
      )}

      <div className="bg-white p-3 p-md-4 rounded border border-light shadow-sm text-center">
        {imageLoading && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border txt-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {instructionImage && (
          <img
            src={instructionImage}
            alt="Quick Guide for Each Measure Infographic"
            className="img-fluid rounded"
            style={{
              maxWidth: "100%",
              height: "auto",
              display: imageLoading ? "none" : "block",
              margin: "0 auto",
            }}
            onLoad={() => setImageLoading(false)}
            onError={() => {
              setImageLoading(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Instruction;
